<template>
    <div class='regiCateNaviBox'>
        <!-- tab 왼쪽 화살표 -->
        <button type='button' class='navi-arrow prev'>
            <span @click='moveToTabScroll(-1)'></span>
        </button>
        <div class='mainMenu'>
            <div class='in'>
                <span class='navibg b1'></span>
                <ul class='ul hori-list'>
                    <li
                        v-for='(tab, index) in tabList'
                        :key='tab.code'
                        class='mm'
                        :class='{on: tab.code === currentCode}'
                        @click='onClickTabBtn(tab.code, index)'>
                        <a>{{tab.name}}</a>
                    </li>
                </ul>
                <span class='navibg b2'></span>
            </div>
        </div>
        <!-- tab 오른쪽 화살표 -->
        <button type='button' class='navi-arrow next'>
            <span @click='moveToTabScroll(1)'></span>
        </button>
    </div>
</template>
<script>
import { MAIN_TAB_CONTAINER } from '@/utils/EndPoint'
import Vue from 'vue'
export default Vue.extend({
  name: MAIN_TAB_CONTAINER,
  props: [
    'tabList',
    'currentCode', // code of currently focused tab
    'methodForTab', // tab 클릭 시 호출할 method
    'categoryIndex'
  ],
  methods: {
    moveNextTab (isReverse = false) {
      const { tabList, categoryIndex } = this
      let moveIdx = 0
      const maxIdx = tabList.length - 1
      const numIdx = Number(categoryIndex) // 문자열 -> 숫자 변환
      if (isReverse) {
        // < 버튼일 경우
        moveIdx = numIdx - 1 < 0 ? maxIdx : numIdx - 1
      } else {
        // > 버튼일 경우
        moveIdx = numIdx + 1 > maxIdx ? 0 : numIdx + 1
      }
      this.onClickTabBtn(tabList[moveIdx].code, moveIdx)
    },
    onClickTabBtn (tabCode, index) {
      this.$emit('update:categoryIndex', index)
      this.methodForTab(tabCode)
    }
  }
})
</script>
